import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {AppConstant} from './app/shared/utility/app-constant';

declare global {
  interface Window {
    __CYPRESS_RUNNING__?: boolean;
  }
}

const trackErrors: boolean = environment.env === 'Production';

if (!window.__CYPRESS_RUNNING__ && trackErrors) {
  Sentry.init({
    dsn: 'https://50151dd88c506ff907a7e7b7eb0d2dfd@o4509648236838912.ingest.us.sentry.io/4509648266461184',
    release: 'papertrl-angular@' + require('package.json').version,
    sendDefaultPii: true,
    ignoreErrors: AppConstant.SENTRY_IGNORE_ERROR_STRING,
    environment: environment.env,
    replaysSessionSampleRate: trackErrors ? 0.1 : 0,
    replaysOnErrorSampleRate: trackErrors ? 1.0 : 0,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],

    beforeSend(event, hint) {
      const isElectron = navigator.userAgent.includes('Electron');
      const isManual = !!hint?.originalException;

      // Don't capture anything in Electron
      if (isElectron) {
        return null;
      }

      // LOCAL ENV: allow only manual captures
      if (!trackErrors) {
        return isManual ? event : null;
      }

      // PRODUCTION environment — filter unknowns only
      const errorMessage = event?.exception?.values?.[0]?.value || event?.message;
      if (!errorMessage || errorMessage === '<Unknown>' || errorMessage.toLowerCase().includes('unknown')) {
        return null;
      }

      return event;
    }
  });

  const tenantId = JSON.stringify(localStorage.getItem(AppConstant.SUB_CLIENT_ID) ||
    JSON.parse(localStorage.getItem(AppConstant.SESSION_USER_ATTR))?.tenantId);

  const email = JSON.parse(localStorage.getItem(AppConstant.SESSION_USER_ATTR))?.email;

  if (email || tenantId) {
    Sentry.setUser({
      id: tenantId,
      email
    });
  }
}


if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error(err));
